import React, {useContext, useEffect, useState} from "react";
import {getAllRelatives, getClueButton, getTrackPlanButton} from "@/services/saleOpServices.ts";
import ClueDetailContext from "@/pages/clueManage/clueDetail/clueDetailContext.ts";
import {STitle} from "shj-components";

import styles from '../../index.module.less'
import classNames from "classnames";
import {useSetState} from "ahooks";
import {Button, Tooltip} from "antd";
import AllowcateWorkerModal from "@/components/AllowcateWorkerModal";
import {useSearchParams} from "react-router-dom";
import {getUserIdentityPage} from "@/services/user.ts";
import AllowChannelWorkerModal from "@/components/AllowChannelWorkerModal";
import {iiHOC} from "@/utils/auth.ts";
import DataElement from "@/pages/clueManage/clueDetail/components/UserInfo/TrackAssignBtn.tsx";
import {getUser} from "shj-utils";

const saleOrder = [
  'subsidiary.seatman', //云客服
  'call.manager', //云客服经理
  'groupHead.electricCommsnr', //电商专员
  'groupHead.electricMnr', //电商经理
  'subsidiary.salesman', //营销员
  'subsidiary.salesMnr', //营销员经理
  'subsidiary.deliveryAchievement', //关联交付业绩人员
  'subsidiary.deliveryAchievementMnr', //关联交付业绩部门经理
];

const designOrder = {
  'productTypeOverall': [ // 整装
    'subsidiary.designer', //整装设计师
    'subsidiary.designMnr', //整装设计部经理
    'subsidiary.chuGuiWardrobeDesign', //橱柜设计师
    'subsidiary.tailorMadeDesign', //定制设计师
    'subsidiary.deepeningDesigner', //深化设计师
  ],
  'productTypeSoft': [ // 软装
    'subsidiary.designer', //软装设计师
    'subsidiary.designMnr', //软装设计部经理
    'subsidiary.achievementDesign', //关联业绩设计师
    'subsidiary.deepeningDesigner', //深化设计师
  ],
  'productTypeCustomizePackage': [ // 定制
    'subsidiary.designer', //定制设计师
    'subsidiary.designMnr', //定制设计部经理
    'subsidiary.achievementDesign', //关联业绩设计师
    'subsidiary.deepeningDesigner', //深化设计师
  ],
  'productTypeBureau': [ // 局改
    'subsidiary.designer', //局改设计师
    'subsidiary.designMnr', //局改设计部经理
    'subsidiary.achievementDesign', //关联业绩设计师
    'subsidiary.deepeningDesigner', //深化设计师
  ],
  'productTypeRetail': [ ], // 零售
};

const Service = () => {
  const [search] = useSearchParams()
  const clueId = search.get('clueId')
  const userInfo = getUser()
  const {detailState,trackDetail, updateDetail} = useContext(ClueDetailContext)

  const [openAllowcateModal, setOpenAllowcateModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [titleStr, setTitleStr] = useState('');
  const [chooseButtonKey, setChooseButtonKey] = useState('');
  const [trackPlanNodeId, setTrackPlanNodeId] = useState('');
  const [trackPlanId, setTrackPlanId] = useState('');
  const [state, setState] = useSetState({
    serviceList: {},
    buttons: []
  })

  useEffect(() => {
    if (detailState.id) getInfo()
    if (clueId){
      trackDetail.id && getButton()
    } else {
      detailState.id && getButton()
    }
  }, [detailState.id, trackDetail.id, clueId, detailState.isReloadNode]);

  const getInfo = () => {
    getAllRelatives(detailState.id).then(res => {
      const {channelClueRelatives = {}, designRelatives = [], salesRelatives = []} = res
      const sortedSalesRelatives = salesRelatives.sort((a, b) => {
        const indexA = saleOrder.indexOf(a.dutyType);
        const indexB = saleOrder.indexOf(b.dutyType);
        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
      });
      const designOrderKeys = Object.keys(designOrder);
      const sortedDesignRelatives = [...designRelatives]
          .sort((a, b) => {
            return designOrderKeys.indexOf(a.bizType) - designOrderKeys.indexOf(b.bizType);
          })
          .map(item => {
            const { bizType, relatives } = item;
            const order = designOrder[bizType] || [];
            return {
              ...item,
              relatives: order.length > 0 ? [...relatives].sort((a, b) => {
                const indexA = order.indexOf(a.dutyType);
                const indexB = order.indexOf(b.dutyType);
                return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
              }) : relatives,
            };
          });
      console.log(sortedDesignRelatives, 'sort')
      setState({serviceList: {channelClueRelatives, salesRelatives: sortedSalesRelatives, designRelatives: sortedDesignRelatives}})
    })
  }

  const getButton = () => {
    const apiFn = clueId ? getTrackPlanButton : getClueButton
    const id = clueId ? trackDetail.id : detailState.id
    apiFn(id).then(res => {
      setState({buttons: res.filter(btn => btn.taskType === 'assign')})
    })
  }

  const {channelClueRelatives = {}, designRelatives = [], salesRelatives = []} = state.serviceList

  const handleopenAllowcateModal = (buttonKey, trackPlanNodeId, trackPlanId, str = '改派') => {
    console.log(buttonKey, 111)
    setTrackPlanNodeId(trackPlanNodeId)
    setTrackPlanId(trackPlanId)
    setTitleStr(str)
    setChooseButtonKey(buttonKey)
    setOpenAllowcateModal(true);
  }

  const reload = () => {
    updateDetail({isReload: !detailState.isReload, isReloadNode: !detailState.isReloadNode})
  }

  const getSaleBtn = (data, duty, bizTypeName?, type?) => {
    const currentBtn = state.buttons?.find(btn => btn.duty === duty) || {}
    const isFind = data.find(item => item.dutyType === currentBtn.duty)
    if (isFind) {
      return <Button type={type}
          style={{ height: '22px', paddingTop: 0, paddingBottom: 0 }}
          onClick={() => handleopenAllowcateModal(currentBtn.buttonKey || 'REASSIGN_SALES', isFind.trackPlanNodeId, isFind.trackPlanId)}>改派</Button>;
    }
  }

  const dispatchEmp = (buttonKey: string, str = '关联') => {
    setOpenAllowcateModal(true)
    setTitleStr(str)
    setChooseButtonKey(buttonKey)
  }

  const dispatchChannelEmp = () => {
    // if(!detailState.channelClueId){
    //   return SMessage.confirm({
    //     title: '非第三方流量无需绑定渠道人员',
    //     content: null,
    //   })
    // }
    setOpen(true)
  }

  return <div>{
    detailState.isPublicSea ? null : iiHOC(
      <div style={{width: '100%', whiteSpace: 'nowrap', overflowX: 'auto', lineHeight: '14px', display: 'flex', marginBottom: '15px', color: 'var(--theme-color)'}}>
        <div style={{ marginRight: 15, fontSize: '10px', cursor: 'pointer' }} datareskey={'assignChannelPeople'} onClick={dispatchChannelEmp}>绑定渠道人员</div>
        {/*<div style={{ marginRight: 15, fontSize: '10px', cursor: 'pointer' }} onClick={() => dispatchEmp('ASSIGN_SEAT_MAN', '分配')}>分配云客服</div>*/}
        <div style={{ fontSize: '10px', cursor: 'pointer' }} datareskey={'assignDeliveryAchievement'} onClick={() => dispatchEmp('ASSIGN_DELIVERY_ACHIEVEMENT')}>关联交付业绩人员</div>
      </div>
    )}
    <STitle title={'渠道阶段'} style={{marginBottom: 10}}/>
    <div className={classNames([styles.mb20])}>
      {channelClueRelatives ? <div className={classNames([styles.mb20])}>
          <p className={styles.mb20} style={{flex: 1}}>主播: {channelClueRelatives.anchorName}</p>
          <p className={styles.mb20} style={{flex: 1}}>直播运营: {channelClueRelatives.liveOperationName}</p>
          <p className={styles.mb20} style={{flex: 1}}>优化师: {channelClueRelatives.advertName}</p>
        </div>
      : null}
    </div>
    <STitle title={<div className={styles.flexBetweenCenter}>
      <p>营销阶段</p>
    </div>}
            style={{marginBottom: 10}}/>
    <div className={classNames([styles.mb20])}>
      {salesRelatives?.map?.(item => {
        return ( 
        <div>
          <div className={classNames([styles.flexStart])} style={{alignItems: "center"}}>
            <p style={{flex: 1, flexBasis: '30%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}><Tooltip title={`${item.dutyTypeName}: ${item.name}`}>{item.dutyTypeName}: {item.name}</Tooltip></p>
            <p style={{flex: 1, flexBasis: '20%', display: "flex", justifyContent: "flex-end"}}>{detailState.isPublicSea ? null : getSaleBtn(salesRelatives, item.dutyType, '', 'link')}</p>
          </div>
          <p style={{flex: 1, flexBasis: '30%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginBottom: '20px'}}>部门: {item.deptName}</p>
        </div>)
      })}
    </div>
    {designRelatives?.map?.(item => {
      const {relatives, bizTypeName} = item
      return <>
        <STitle title={<div className={styles.flexBetweenCenter}>
          <p>{`设计阶段-${bizTypeName || ''}`}</p>

        </div>} style={{marginBottom: 10}}/>
        <div className={classNames([styles.mb20])}>
          {relatives?.map(person => <div><div className={classNames([styles.flexStart])} style={{alignItems: "center"}}>
                  <p style={{flex: 1, flexBasis: '30%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}
                    title={person.name}><Tooltip title={`${person.dutyTypeName}: ${person.name}`}>{person.dutyTypeName}: {person.name}</Tooltip></p>
                  <p style={{flex: 1, flexBasis: '20%', display: "flex", justifyContent: "flex-end"}}>
                    {detailState.isPublicSea ? null : <DataElement
                        id={person.trackPlanId}
                        btns={state.buttons}
                        data={relatives}
                        duty={person.dutyType}
                        handleopenAllowcateModal={handleopenAllowcateModal}
                    />}
                  </p>
                </div>
                <p style={{flex: 1, flexBasis: '30%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginBottom: '20px' }}>部门: {person.deptName}</p>
              </div>
          )}
        </div>
      </>
    })}

    {/** 分配服务人员弹窗 */}
    {openAllowcateModal &&
        <AllowcateWorkerModal orgId={userInfo.companyId} tab={''} buttonKey={chooseButtonKey} reload={reload}
                              editId={detailState.id} open={openAllowcateModal}
                              trackPlanNodeId={trackPlanNodeId}
                              trackPlanId={trackPlanId}
                              isEditTitle={titleStr}
                              requestApi={getUserIdentityPage}
                              // submitApi={!chooseButtonKey ? channelClueUpdate : ''}
                              onClose={() => setOpenAllowcateModal(false)}/>}
    <AllowChannelWorkerModal open={open}
                             reload={reload} editId={detailState.channelClueId} clueId={detailState.id}
                             onClose={() => setOpen(false)} />
  </div>
}

export default Service
